import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import FlagIcon from '@mui/icons-material/Flag';
import MapIcon from '@mui/icons-material/Map';
import RoomIcon from '@mui/icons-material/Room';
import HomeIcon from '@mui/icons-material/Home';
import RecommendIcon from '@mui/icons-material/Recommend';
import ListIcon from '@mui/icons-material/List';
import BenfitIcon from '@mui/icons-material/WorkspacePremium';
import BusinessIcon from '@mui/icons-material/Business';
import Notifications from '@mui/icons-material/Notifications';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import InsertLink from '@mui/icons-material/InsertLink';
import PhishingIcon from '@mui/icons-material/Phishing';
import PublicIcon from '@mui/icons-material/Public';

import routes from './routes';

const sideNavItems = [
  {
    name: routes.home.title,
    icon: HomeIcon,
    redirectTo: routes.home.path,
  },
  {
    name: routes.users.title,
    icon: PeopleAltIcon,
    redirectTo: routes.users.path,
  },
  {
    name: routes.userReports.title,
    icon: FlagIcon,
    redirectTo: routes.userReports.path,
  },
  {
    name: routes.countries.title,
    icon: PublicIcon,
    redirectTo: routes.countries.path,
  },
  {
    name: routes.cities.title,
    icon: MapIcon,
    redirectTo: routes.cities.path,
  },
  {
    name: routes.spots.title,
    icon: RoomIcon,
    redirectTo: routes.spots.path,
  },
  {
    name: routes.recommendations.title,
    icon: RecommendIcon,
    redirectTo: routes.recommendations.path,
  },
  {
    name: routes.lists.title,
    icon: ListIcon,
    redirectTo: routes.lists.path,
  },
  {
    name: routes.benefits.title,
    icon: BenfitIcon,
    redirectTo: routes.benefits.path,
  },
  {
    name: routes.notifications.title,
    icon: Notifications,
    redirectTo: routes.notifications.path,
  },
  {
    name: routes.autoNotification.title,
    icon: NotificationsActiveIcon,
    redirectTo: routes.autoNotification.path,
  },
  {
    name: routes.businessOwner.title,
    icon: BusinessIcon,
    redirectTo: routes.businessOwner.path,
  },
  {
    name: routes.links.title,
    icon: InsertLink,
    redirectTo: routes.links.path,
  },
  {
    name: routes.webHooks.title,
    icon: PhishingIcon,
    redirectTo: routes.webHooks.path,
  },
];

export default sideNavItems;
